import { Brand } from '@blade/std-lib'

export const CustomEmojiIdTypeId = 'tradebot-tma/CustomEmojiId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type CustomEmojiIdTypeId = typeof CustomEmojiIdTypeId

export type CustomEmojiId = Brand.Branded<string, CustomEmojiIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomEmojiId = Brand.nominal<CustomEmojiId>()
